import React from "react";
import { FormItem, FormItemProps } from './FormItem';
import { IField, getRequiredError } from './FieldValidation';
import { Option } from "./Options";
import AsyncSelect from "react-select/async";
import { selectStyles } from "./SelectField";
import { ErrorText } from "./ErrorText";
import { IndustryController } from "../../controllers/IndustryController";

export interface AnzicOption extends Option<string> {}

export interface AnzicFieldProps extends FormItemProps {
    id: string;
    onChange: (value: AnzicOption | null) => void;
    value: AnzicOption | null;
    required?: boolean;
    requiredMessage?: string;
    disabled?: boolean;
}

export interface AnzicFieldState {
    defaultOptions?: AnzicOption[];
    errorText?: string;
}

declare var google: any;

const uri = 'https://industrycoder.abs.gov.au/pocc?s=';

export class AnzicField extends React.Component<AnzicFieldProps, AnzicFieldState> implements IField {
    inputRef: React.RefObject<any> = React.createRef();
    ajax: IndustryController;

    constructor(props: AnzicFieldProps) {
        super(props);
        this.ajax = new IndustryController();
        this.state = {};
    }

    componentDidMount() {
        this.load();
    }

    componentDidUpdate(prevProps: AnzicFieldProps) {
        if (this.props.value !== prevProps.value) {
            if (this.state.errorText) {
                this.validate(() => {});
            }
            this.load();
        }
    }

    componentWillUnmount() {
        this.ajax.cancel();
    }

    load = () => {
        this.ajax.cancel();

        if (this.props.value) {
            this.ajax.getIndustryMatches(null, this.props.value.label, (defaultOptions) => {
                this.setState({ defaultOptions });
            });
        } else {
            this.setState({ defaultOptions: [] });
        }
    };

    search = (input: string, callback: (options: AnzicOption[]) => void) => {
        this.ajax.cancel();

        this.ajax.getIndustryMatches(null, input, (d) => {
            callback(d);
        });
    };

    render() {
        if (this.props.preview) {
            return (
                <FormItem {...this.props} errorMessage={this.state.errorText}>
                    <div className="form-value">{this.props.value && this.props.value.label}</div>
                </FormItem>
            );
        }

        return (
            <FormItem {...this.props} inputId={this.props.id}>
                <AsyncSelect
                    styles={selectStyles(true, !!this.state.errorText)}
                    id={this.props.id}
                    placeholder="Search..."
                    ref={this.inputRef}
                    value={this.props.value}
                    isClearable={true}
                    onChange={(v) => this.props.onChange(v as AnzicOption)}
                    loadOptions={this.search}
                    defaultOptions={this.state.defaultOptions}
                />
                <ErrorText text={this.state.errorText} />
            </FormItem>
        );
    }

    focus() {
        if (this.inputRef.current) {
            const selectElement = this.inputRef.current as any;
            if (selectElement && selectElement.focus) {
                selectElement.focus();
            }
        }
    }

    getErrorText(): string | null {
        if (this.props.required) {
            if (!this.props.value) {
                return getRequiredError(this.props);
            }
        }
        return null;
    }

    validate(callback: (res: boolean) => void, focus?: boolean) {
        const errorText = this.getErrorText();
        this.setError(errorText, () => {
            if (errorText && focus) {
                this.focus();
            }
            callback && callback(!errorText);
        });
    }

    setError(errorText?: string, callback?: () => void) {
        this.setState({ errorText }, callback);
    }
}
